var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"pv-display"},[_c('div',{staticClass:"pv-number-box"},_vm._l((_setup.pvDigits),function(digit,index){return _c('div',{key:index,staticClass:"pv-digit"},[_vm._v(_vm._s(digit))])}),0)]),_c('p',[_vm._v(" copyright 2025 顺昌县博物馆版权信息 闽ICP备2024034970号-2")])])
}
var staticRenderFns = []

export { render, staticRenderFns }